import { KeyValueObject } from "@components/common/types/general";
import { getColorVariable } from "@components/common/utils/helper";
import { ArrowProps } from "./arrow";

export function getBackgroundColor(color: ArrowProps["color"], theme: any): KeyValueObject {
    if (color) {
        return {
            backgroundColor: getColorVariable(color, theme, {
                gray: theme.colors.gray[500],
                white: theme.colors.white,
                colorize: theme.colors[color || "primary"][500],
                default: theme.colors.gray[950],
            }),
        };
    } else {
        return { backgroundColor: theme.colors.gray[950] };
    }
}
